import React from "react";
import id from "@irati/utils/id";
import { getBrandLogo } from "@irati/utils/images/getImageSize/getImageSize";
import { BRAND_LOGO_DIMENSIONS } from "@irati/brand/constants/brand";
import withBranding from "@irati/brand/withBranding";
import { BrandedImg } from "./styled";
var HeaderBrand = function (props) {
    var branding = props.branding;
    var idNamespace = id("header-brand", props);
    var brandLogoUrl = branding.businessLogoUrl;
    var imageUrl = getBrandLogo(brandLogoUrl, BRAND_LOGO_DIMENSIONS.width, BRAND_LOGO_DIMENSIONS.height);
    return React.createElement(BrandedImg, { id: id("img", idNamespace), alt: "brand logo", src: imageUrl });
};
export default withBranding(HeaderBrand);
